import { RadioGroup } from 'devextreme-react'
import React, { useEffect, useState } from 'react'
import { Card, CardFooter, Col, Row } from 'reactstrap'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'sweetalert2/src/sweetalert2.scss'
import Breadcrumb from '../../components/common/breadcrumb'
import SorgulamaEkrani from '../../components/common/sorgulama-component/sorgulama-ekrani'
import useFormatMessage from '../../utils/useFormatMessage'
import HasarBildirimiAddModal from '../hasar-bildirimi/components/HasarBildirimiAddModal'
const RihtimIade = () => {

    const [isOpen, setIsOpen] = useState(false)
    const { t } = useFormatMessage()
    const [data, setData] = useState(null)

    useEffect(() => {
        if (!data) return

        if (data.error) {
            // Hata durumunda
            if (navigator.vibrate) {
                navigator.vibrate(500)
            }
            const errorAudio = document.getElementById("errorSound")
            errorAudio.play()

            Swal.fire({
                icon: 'error',
                title: 'Hata',
                html: `<div style="font-size: 24px;">${t(data.error)}</div>`,
                showConfirmButton: true,
                confirmButtonText: 'Tamam',
                allowOutsideClick: false,
                allowEscapeKey: false,
                background: '#fff5f5',
                customClass: {
                    popup: 'swal2-popup-large'
                }
            })
            return
        }

        if (data.address) {
            Swal.fire({
                icon: 'success',
                title: 'Yönlendirme',
                html: `<div style="font-size: 24px;">${data.address}</div>`,
                timer: 3000,
                showConfirmButton: false,
                position: 'center',
                allowOutsideClick: false,
                customClass: {
                    popup: 'swal2-popup-large'
                }
            }).then(() => {
                // 5 saniye sonra input'u temizle ve fokusla
                const input = document.querySelector('input[type="text"]')
                if (input) {
                    input.value = ''
                    input.focus()
                }
            })
        }
        // eslint-disable-next-line
    }, [data])

    return (
        <div>
            <Breadcrumb current={t("Rıhtım'a İade")} />
            <Card>
                <Row className='m-3'>
                    <Col md="12">
                        <RadioGroup
                            items={["Rıhtım'a İade", "Hasar Bildir"]}
                            defaultValue={"Rıhtım'a İade"}
                            itemRender={(data) => {
                                return (
                                    <div>
                                        <span>{t(data)}</span>
                                    </div>
                                )
                            }}
                            stylingMode='outlined'
                            layout='horizontal'
                            onValueChange={(e) => {
                                if (e === "Hasar Bildir") {
                                    document.querySelector('.hasar-bildirimi').style.display = "block";
                                }
                                else document.querySelector('.hasar-bildirimi').style.display = "none"
                            }}
                        />
                    </Col>
                </Row>

                <SorgulamaEkrani apiEndpoint="/dockEnter" setData={setData}
                    role_name={"gumruklusaha_iade_write"}
                />
                <CardFooter style={{
                    textAlign: "right", color: "red", cursor: "pointer",
                }}>
                    <i className='hasar-bildirimi'
                        style={{ display: "none" }}
                        onClick={
                            () => setIsOpen(!isOpen)
                        }>
                        {t("Hasar Bildir")}
                    </i>
                </CardFooter>
            </Card>

            <HasarBildirimiAddModal isOpen={isOpen} setIsOpen={setIsOpen} area="PDI Giriş" />

        </div>
    )
}

export default RihtimIade